import React, { Component } from 'react';
import rightArrow from '../../assets/images/scroll/scroll-right-btn@3x.png';
class ScrollRight extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div className='scroll-container'>
                <div className='scroll-img'>
                    <img src={rightArrow} alt='right' />
                </div>
            </div>
        );
    }
}

export default ScrollRight;
